import React from 'react';

interface CheckboxProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  width?:string;
}

const Checkbox: React.FC<CheckboxProps> = ({ label, checked, onChange, disabled = false,width }) => {
  return (
    <>
    <div className="form-check mb-3 me-3" style={{width:width?width:'400px'}}>
    <input className="form-check-input" type="checkbox" disabled={disabled} 
    onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.checked)}
    checked={checked} id={label}/>
    <label className="form-check-label" htmlFor={label}>
        {label}
    </label>
    </div>
</>
  );
};

export default Checkbox;